import React, { Component } from 'react';
import { connect } from 'react-redux'
import './style.scss';
import StaticItem from './StaticItem';

class QuizAnswers extends Component {
  render() {
    const {data, quiz} = this.props;
    return (
      <div style={{marginTop: '40px'}}> 
        {data.map((item, index) => <StaticItem key={'item-stat-' + item.id} item={item} questions_length={item.count_questions || quiz.questions_count} index={index} />)}  
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  data: state.statistic_report.quiz_student_answers,
  quiz: state.statistic_report.quiz,
  
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(QuizAnswers)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/StatisticReports/QuizAnswers/index.jsx